export default __webpack_public_path__ + "static/media/sanya2.3decc0ab.webp";